import AboutWelcomeBlock from "../common/blocks/AboutWelcomeBlock";
import BestFacilitesBlock from "../common/blocks/BestFacilitesBlock";
const About = () => {
	return (
	<>		
		<AboutWelcomeBlock />
		<BestFacilitesBlock />
	</>
	);
};
export default About;